import React, { useState, useEffect } from "react";
import MakeCall from "../MakeCall";
import CallScreen from "../CallScreen";

const Home: React.FC = () => {
  const [callState, setcallState] = useState<string>("initial");
  const [corlmiNumber, setcorlmiNumber] = useState<string>();
  const [error, seterror] = useState<string>();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const pathSegment = window.location.pathname.split("/").filter(Boolean)[0];
    const number =
      pathSegment || new URLSearchParams(window.location.search).get("corlmi_number");
    if (number) {
      setNumber(number);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (state: string, err?: string) => {
    if (err) seterror(err);
    setcallState(state);
    if (state === "call") seterror(undefined);
  };

  const setNumber = (number: string) => {
    const cleaned = number.replace(/-/g, "").toUpperCase();
    const formatted = cleaned.replace(/(.{3})/g, "$1-").replace(/-$/, "");
    setcorlmiNumber(formatted);
  };

  return (
    <div>
      {callState === "call" && corlmiNumber ? (
        <CallScreen corlmiNumber={corlmiNumber} changeState={handleChange} />
      ) : (
        <MakeCall
          changeState={handleChange}
          changeNumber={setNumber}
          number={corlmiNumber}
          error={error}
        />
      )}
    </div>
  );
};

export default Home;
